export const WELL_REG_BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/well-registrations-management`;

export const WELL_REG_PK_FIELD = "well_reg_ndx";

export const COLUMNS = [
  {
    field: "well_reg_ndx",
    headerName: "Well Reg",
    width: 160,
    editable: false,
    type: "number",
  },
  {
    field: "well_ndx",
    headerName: "Well",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "contact_ndx",
    headerName: "Contact",
    width: 160,
    editable: true,
    type: "number",
  },
  { field: "id", headerName: "Id", width: 160, editable: true, type: "number" },
  {
    field: "id_well_reg",
    headerName: "Id Well Reg",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "id_well_twdb",
    headerName: "Id Well Twdb",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "id_well_report_tracking_number",
    headerName: "Well Report Tracking Number SDR",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "dt_received",
    headerName: "Dt Received",
    width: 160,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "id_well",
    headerName: "Id Well",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "id_contact_owner",
    headerName: "Id Contact Owner",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "id_contact_driller",
    headerName: "Id Contact Driller",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "id_contact_installer",
    headerName: "Id Contact Installer",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "id_contact_preparer",
    headerName: "Id Contact Preparer",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "id_well_reg_purpose",
    headerName: "Id Well Reg Purpose",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "id_well_purpose",
    headerName: "Id Well Purpose",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "alter_desc",
    headerName: "Alter Desc",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "dt_start_drill",
    headerName: "Dt Start Drill",
    width: 160,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "ft_closest_property_line",
    headerName: "Ft Closest Property Line",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "ft_existing_well",
    headerName: "Ft Existing Well",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "ft_contaminate",
    headerName: "Ft Contaminate",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "ft_waste_water",
    headerName: "Ft Waste Water",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "ft_septic_tank",
    headerName: "Ft Septic Tank",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "fl_meets_spacing_req",
    headerName: "Fl Meets Spacing Req",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_within_50_ft_pws",
    headerName: "Fl Within 50 Ft Pws",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "pws",
    headerName: "Pws",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "size_borehole",
    headerName: "Size Borehole",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "size_casing",
    headerName: "Size Casing",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "depth_well",
    headerName: "Depth Well",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "size_pump",
    headerName: "Size Pump",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "cap_production",
    headerName: "Cap Production",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "loc_water_use",
    headerName: "Loc Water Use",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "fl_residential",
    headerName: "Fl Residential",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_domestic",
    headerName: "Fl Domestic",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_agricultural",
    headerName: "Fl Agricultural",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "num_ag_registration",
    headerName: "Num Ag Registration",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "fl_geothermal_exempt",
    headerName: "Fl Geothermal Exempt",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "num_geothermal_exempt",
    headerName: "Num Geothermal Exempt",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    name: "fl_wildlife",
    headerName: "Fl Wildlife Management Well",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_irrigation",
    headerName: "Fl Irrigation",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_pws",
    headerName: "Fl Pws",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_community_ws",
    headerName: "Fl Community Ws",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_retail_pws",
    headerName: "Fl Retail Pws",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_commercial",
    headerName: "Fl Commercial",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_dewatering",
    headerName: "Fl Dewatering",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_industrial",
    headerName: "Fl Industrial",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_injection",
    headerName: "Fl Injection",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_monitor",
    headerName: "Fl Monitor",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_aquifer_test_obser",
    headerName: "Fl Aquifer Test Obser",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_aquifer_test_pump",
    headerName: "Fl Aquifer Test Pump",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_remediation",
    headerName: "Fl Remediation",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_geothermal_non_exempt",
    headerName: "Fl Geothermal Non Exempt",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "fl_other",
    headerName: "Fl Other",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "other_desc",
    headerName: "Other Desc",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "fl_other_exempt",
    headerName: "Fl Other Exempt",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "doc_well_registration",
    headerName: "Doc Well Registration",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "doc_plat",
    headerName: "Doc Plat",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "doc_confirmation",
    headerName: "Doc Confirmation",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "doc_state_well_report",
    headerName: "State Well Number GWDB",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "doc_other",
    headerName: "Doc Other",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "amt_paid",
    headerName: "Amt Paid",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "payment_method",
    headerName: "Payment Method",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "stripe_reference_number",
    headerName: "Stripe Reference Number",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "payment_status",
    headerName: "Payment Status",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "check_number",
    headerName: "Check Number",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "real_estate_txn",
    headerName: "Real Estate Txn",
    width: 160,
    editable: true,
    type: "number",
  },
  {
    field: "real_estate_txn_number",
    headerName: "Real Estate Txn Number",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "comment",
    headerName: "Comment",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "dt_approved",
    headerName: "Dt Approved",
    width: 160,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "approved_by_user",
    headerName: "Approved By User",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "created_by_user",
    headerName: "Created By User",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "updated_by_user",
    headerName: "Updated By User",
    width: 160,
    editable: true,
    type: "string",
  },
  {
    field: "created_dt_gmt",
    headerName: "Created Dt Gmt",
    width: 160,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "updated_dt_gmt",
    headerName: "Updated Dt Gmt",
    width: 160,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
];
